import script from "./EventsDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./EventsDetailPage.vue?vue&type=style&index=0&id=4fd4c60a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd4c60a"]])

export default __exports__